import { StyledProps } from '@front10';
import * as React from 'react';
import { useTranslation } from '@front10/utils';
import { strSplitFormat } from '../../../helpers/utils';
import Box from '../../elements/Box';
import Link from '../../elements/Link';

interface StationLink {
  url: string;
  name: string;
}

interface Props {
  links: StationLink[];
}

export function StationsInterlink({ links, ...props }: StyledProps<Props>) {
  const translate = useTranslation();
  if (links.length > 0) {
    const text = links[1]
      ? translate(
          'cmp-bus-directory-interlink-more-alt',
          'Looking for other stations in {0} or {1}?'
        )
      : translate('cmp-bus-directory-interlink-more', 'Looking for other stations in {0}?');
    return (
      <Box {...props}>
        {strSplitFormat(
          text,
          ...links.map((link) => (
            <Link key={link.url} href={link.url}>
              {link.name}
            </Link>
          ))
        )}
      </Box>
    );
  }
  return null;
}
